<template>
    <b-container class='report-page'>
        <b-row>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('import_log_report.import_type') }}</label>
                        <vSelect :options="importTypeOptions" v-model="selectedImportType" :reduce="type => type.id"/>
                    </b-form-group>
                </b-col>
                <b-col>
                </b-col>
        </b-row>

        <b-row>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('import_log_report.date') }}</label>
                        <vSelect :options="dateOptions" v-model="selectedDate" />
                    </b-form-group>
                </b-col>
                <b-col>
                </b-col>
        </b-row>

        <b-row v-if="$UIPrivilege('reports/importlog', 'all_levels')">
                <b-col>
                    <b-form-group>
                        <label>{{ $t('import_log_report.level') }}</label>
                        <vSelect :options="$t('import_log_report.levels')" v-model="selectedLevel" />
                    </b-form-group>
                </b-col>
                <b-col>
                </b-col>
        </b-row>


        <b-row>
            <b-col>
                    <b-table
						striped
                        small
						:items="logItems"
						:fields="logFields"
						:per-page="perPage"
						:current-page="logCurrentPage"
                        :busy="loading"
                        sticky-header="700px"
                        tbody-class="tableClass"
                        tbody-tr-class="trClass">
                        <template #table-busy>
                            <Loading />
                        </template>
                    </b-table>

                    <TablePagination
						:total-rows="totalRows"
						:per-page="perPage"
                        :currentPage="logCurrentPage"
						@pageChange="onPageChange"
					>
					</TablePagination>
            </b-col>
        </b-row>

    </b-container>
</template>


<script>
import TablePagination from '@/components/Misc/TablePagination';
import importLogReport  from '@/store/reports/importLogReport'
import vSelect from 'vue-select'
import moment from "moment";


export default {
    components: {vSelect, TablePagination},
    data: function() {
        return {
            perPage: 300,
            logCurrentPage: 1,
            loading: false,
            selectedImportType: null,
            selectedDate: null,
            selectedLevel: this.$t('import_log_report.levels')[0]
        }
    },
    computed: {
        importTypeOptions() {
            var typeOptions = [];
            for(var type of this.$store.state.importLogReport.importLogTypesList){
                typeOptions.push({id:type.id, label:this.$t('import_log_report.importLogType.' + type.id)})
            }
            return typeOptions;
        },
         dateOptions(){
            var dateOptions = []
            var importType = this.$store.state.importLogReport.importLogTypesList.find(type => type.id == this.selectedImportType);
            if(importType != undefined) dateOptions = importType.logDates;
            return dateOptions;
         },
         logItems(){
             return this.$store.state.importLogReport.importLogsList.filter((log) => {
                 if(this.selectedLevel == "debug") return true
                 if(this.selectedLevel == "info") return ["info", "warn", "error", "user"].includes(log.level.toLowerCase())
                 if(this.selectedLevel == "warn") return ["warn", "error", "user"].includes(log.level.toLowerCase())
                 if(this.selectedLevel == "error") return ["error", "user"].includes(log.level.toLowerCase())
                 if(this.selectedLevel == "user") return "user" == log.level.toLowerCase() 

                 return false;
             });
         },
         logFields(){
             return [
                {   key: 'logTs', label: this.$t('import_log_report.time'), sortable: true,
                    formatter: (value) => {
                        var date = new moment(value)
                        // var dateOptions = {hour: "2-digit", minute: "2-digit", second: "2-digit"}
                        return date.format("HH:mm:ss")
                    }},
                { key: 'level', label: this.$t('import_log_report.level') },
				{ key: 'text', label: this.$t('import_log_report.log') }
            ];
         },
         totalRows() {
			return this.logItems ? this.logItems.length : 0;
		}
    },
    watch: {
        selectedDate() {
            //it is moved to methods because sometimes it is needed to call it manually 
            this.selectedDateChanged()
        },
        selectedLevel() {
            this.logCurrentPage = 1;
        },
        importTypeOptions: {
            immediate: true,
            handler(newVal){
                var defaultType = newVal.find(type => type.id == "timetable_import");
                if(defaultType){
                    this.selectedImportType = defaultType.id;
                }else {
                    this.selectedImportType = null;
                }
            }
        },
        dateOptions: {
            immediate: true,
            handler(newVal){
                var defaultDate = newVal[0];
                if(defaultDate){
                    var oldDate = this.selectedDate
                    this.selectedDate = defaultDate;
                    if(oldDate == defaultDate) 
                        this.selectedDateChanged() //it is called manually when date of previous and current selected import type were the same value, so vue thinks it doesn't change
                }else {
                    this.selectedDate = null;
                }
            }
        }
    },
    beforeCreate() {
        if(!this.$store.hasModule("importLogReport")){
            this.$store.registerModule("importLogReport", importLogReport)
        }
        this.$store.commit("importLogReport/clearImportLogsList");
        this.$store.dispatch("importLogReport/getImportLogTypes")

    },
    methods: {
        onPageChange(page) {
			this.logCurrentPage = page;
		},
        selectedDateChanged(){
            this.logCurrentPage = 1;
            
            if(this.selectedDate == null){
                this.$store.commit("importLogReport/clearImportLogsList");
                return;
            }

            this.loading = true;

            var params = {
                'importlogtype': this.selectedImportType,
                'logdate': this.selectedDate
            }
            this.$store.dispatch("importLogReport/getImportLogs", params)
                .finally(() => {
                    this.loading = false;
                })
        }
    }
}
</script>

<style >
    .tableClass tr.trClass td{ 
        padding: 2px 5px;
    }
</style>